import { themr } from '@friendsofreactjs/react-css-themr';

import PaymentDetails from './PaymentDetails';

export default themr('PaymentDetails')(PaymentDetails);
